<template>
    <BasePanel :icon="CreditCardIcon" :title="$t('wallet.my_wallet')">
        <template v-if="wallet">
            <div class="flex flex-col justify-between md:flex-row">
                <div class="flex w-auto flex-row gap-4 md:flex-col">
                    <p class="mb-2 mt-1 max-w-2xl text-sm text-gray-500">{{ $t('wallet.retrievable_balance') }}</p>
                    <h2 id="applicant-information-title" class="text-xl font-medium leading-6 text-gray-900">
                        {{ formatCurrency(wallet.retrievable_balance, wallet.currency) }}
                    </h2>
                </div>
                <div v-if="isNaturalProfile() && accountState.naturalProfile.vouchers.length">
                    <p class="mb-2 mt-1 max-w-2xl text-sm text-gray-500">{{ $t('wallet.voucher_balance') }}</p>
                    <h2 id="applicant-information-title" class="text-xl font-medium leading-6 text-gray-900">
                        {{ formatCurrency(voucherTotalBalance, getCurrency()) }}
                    </h2>
                </div>
                <div class="mt-4 flex w-full items-end md:mt-0 md:w-auto">
                    <BaseButtonSecondary
                        v-if="!checkWalletFeatureHidden(HideableWalletFeature.Withdrawal)"
                        class="h-10 w-full"
                        href="/wallet?withdrawal=true">
                        {{ $t('wallet.withdrawal_button') }}
                    </BaseButtonSecondary>
                </div>
            </div>
        </template>
        <template v-else>
            <h3 class="mt-2 text-sm font-medium text-gray-900">{{ $t('wallet.no_wallet') }}</h3>
            <p class="mt-1 text-sm text-gray-500" v-html="$t('wallet.no_wallet_description')"></p>
        </template>
    </BasePanel>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CreditCardIcon } from '@heroicons/vue/outline'
import BasePanel from '../../base/BasePanel.vue'
import BaseButtonSecondary from '../../base/BaseButtonSecondary.vue'
import { checkWalletFeatureHidden, HideableWalletFeature } from '../../../utilities/useWalletSettings'
import { Wallet } from '../../../utilities/account/useWallet'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { getCurrency } from '../../../utilities/usePlatformSettings'
import { formatCurrency } from '../../../utilities/helpers'

const accountState = usePersonalAccountDataState()

const voucherTotalBalance = computed(() => {
    if (accountState.naturalProfile.vouchers?.length < 1) {
        return 0
    }

    return accountState.naturalProfile.vouchers.reduce((total, voucher) => {
        return total + voucher.gift_card_balance
    }, 0)
})

defineProps<{
    wallet: Wallet | undefined
}>()
</script>

<style scoped></style>
